module.exports = __webpack_public_path__ + "static/gostin3-9d3f148d56c18059ecd483fd13ecaa2c.webp";